<div class="c-modal">
  <div class="c-modal__header">
    <div class="c-modal__header--title">
      <img src="../../../../assets/madero-logo.svg" alt="Logo Madero" srcset="" />
      <h3>{{ 'MAKE_RESERVATION' | translate }}</h3>
    </div>
    <div class="c-modal__header--language">
      <button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-btn">
        <img
          [src]="'../../../../assets/flags/' + (currentLanguage() === 'pt' ? 'pt-br' : 'es') + '.svg'"
          class="language-flag"
          [alt]="currentLanguage()" />
        <span class="language-code">{{ currentLanguage().toUpperCase() }}</span>
      </button>
      <mat-menu #languageMenu="matMenu">
        <button mat-menu-item (click)="changeLanguage('pt')">
          <img src="../../../../assets/flags/pt-br.svg" class="language-flag-menu" alt="PT" />
          <span>PT</span>
        </button>
        <button mat-menu-item (click)="changeLanguage('es')">
          <img src="../../../../assets/flags/es.svg" class="language-flag-menu" alt="ES" />
          <span>ES</span>
        </button>
      </mat-menu>
    </div>
  </div>

  @if (notFound) {
    <div class="c-finish">
      <div class="c-finish__icon">
        <span class="material-symbols-rounded icon-error"> error </span>
      </div>
      <div class="c-finish__content">
        <h1>{{ 'RESERVATION_MODAL.NOT_FOUND.TITLE' | translate }}</h1>
        <h3>{{ 'RESERVATION_MODAL.NOT_FOUND.SUBTITLE' | translate }}</h3>
      </div>
    </div>
  } @else {
    <div class="c-tabs">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup [tabIndex]="indexTab">
        <mat-tab label="{{ 'RESERVATION_MODAL.TABS.RESERVATION_DATA' | translate }}">
          @if (hidePanels) {
            <div class="c-select-branch">
              <span class="material-symbols-rounded icon"> location_on </span>
              <h1>{{ selectedStore }}</h1>
            </div>
          }
          <form [formGroup]="formreserve">
            <div class="c-accordion">
              <mat-accordion class="c-accordion__container">
                <!-- Estados -->
                <mat-expansion-panel
                  [ngClass]="hidePanels ? 'hide' : ''"
                  [expanded]="step === 0"
                  [disabled]="disableAccordion[0]"
                  (opened)="setStep(0)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP0.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        selectedCity
                          ? selectedCity + '/' + selectedState
                          : ('RESERVATION_MODAL.COMMON.SELECT' | translate)
                      }}
                      @if (loaderState || loaderCity) {
                        <mat-spinner class="c-spinner"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> location_on </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field appearance="outline">
                    <mat-label for="state">{{
                      'RESERVATION_MODAL.STEP0.STATE_LABEL' | translate
                    }}</mat-label>
                    <mat-select
                      id="state"
                      formControlName="state"
                      (selectionChange)="onSelectState($event)">
                      @for (state of listState; track $index) {
                        <mat-option [value]="state.acronym">{{ state.name }}</mat-option>
                      }
                    </mat-select>
                    @if (formreserve.get('state')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP0.STATE_ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>

                  <br />

                  <mat-form-field appearance="outline">
                    <mat-label for="city">{{
                      'RESERVATION_MODAL.STEP0.CITY_LABEL' | translate
                    }}</mat-label>
                    <mat-select
                      id="city"
                      formControlName="city"
                      (selectionChange)="onSelectCity($event)">
                      @for (city of listCity; track $index) {
                        <mat-option [value]="city">{{ city.name }}</mat-option>
                      }
                    </mat-select>
                    @if (formreserve.get('city')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP0.CITY_ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-action-row>
                    <button
                      mat-button
                      color="primary"
                      (click)="nextStep()"
                      [disabled]="onCheckDisable('city')">
                      {{ 'RESERVATION_MODAL.COMMON.NEXT' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>

                <!-- Restaurante -->
                <mat-expansion-panel
                  [ngClass]="hidePanels ? 'hide' : ''"
                  [expanded]="step === 1"
                  [disabled]="disableAccordion[1]"
                  (opened)="setStep(1)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP1.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ selectedStore || ('RESERVATION_MODAL.COMMON.SELECT' | translate) }}
                      @if (loaderStore) {
                        <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> storefront </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field appearance="outline">
                    <mat-label for="unit">{{ 'RESERVATION_MODAL.STEP1.LABEL' | translate }}</mat-label>
                    <mat-select
                      id="unit"
                      formControlName="store"
                      (selectionChange)="onSelectStore($event)">
                      @for (store of listStore; track $index) {
                        <mat-option [value]="store">{{ store.nickName }}</mat-option>
                      }
                    </mat-select>
                    @if (formreserve.get('store')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP1.ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-action-row>
                    <button mat-button color="warn" (click)="prevStep()">
                      {{ 'RESERVATION_MODAL.COMMON.PREVIOUS' | translate }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      (click)="nextStep()"
                      [disabled]="onCheckDisable('store')">
                      {{ 'RESERVATION_MODAL.COMMON.NEXT' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>

                <!-- Salão -->
                <mat-expansion-panel
                  [ngClass]="showPanelHall ? '' : 'hide'"
                  [expanded]="step === 2"
                  [disabled]="disableAccordion[2]"
                  (opened)="setStep(2)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP2.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ selectedHall || ('RESERVATION_MODAL.COMMON.SELECT' | translate) }}
                      @if (loaderHall) {
                        <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> table_bar </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field appearance="outline">
                    <mat-label for="hall">{{ 'RESERVATION_MODAL.STEP2.LABEL' | translate }}</mat-label>
                    <mat-select
                      id="hall"
                      formControlName="hall"
                      (selectionChange)="onSelectHall($event)">
                      @for (hall of listHall; track $index) {
                        <mat-option [value]="hall">{{ hall.hallName }}</mat-option>
                      }
                    </mat-select>
                    @if (formreserve.get('hall')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP2.ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-action-row>
                    <button mat-button color="warn" (click)="prevStep()">
                      {{ 'RESERVATION_MODAL.COMMON.PREVIOUS' | translate }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      (click)="nextStep()"
                      [disabled]="onCheckDisable('hall')">
                      {{ 'RESERVATION_MODAL.COMMON.NEXT' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>

                <!-- Quantas pessoas -->
                <mat-expansion-panel
                  [expanded]="step === 3"
                  [disabled]="disableAccordion[3]"
                  (opened)="setStep(3)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP3.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ selectedPeoples }}
                      @if (loaderPeoples) {
                        <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> group </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field appearance="outline">
                    <mat-label for="people">{{ 'RESERVATION_MODAL.STEP3.LABEL' | translate }}</mat-label>
                    <mat-select
                      id="people"
                      formControlName="peoples"
                      (selectionChange)="onSelectPeople($event)">
                      @for (people of listPeoples; track $index) {
                        <mat-option [value]="people">{{ people }}</mat-option>
                      }
                    </mat-select>
                    @if (formreserve.get('peoples')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP3.ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-action-row>
                    @if (!hidePanels) {
                      <button mat-button color="warn" (click)="prevStep()">
                        {{ 'RESERVATION_MODAL.COMMON.PREVIOUS' | translate }}
                      </button>
                    }
                    <button
                      mat-button
                      color="primary"
                      (click)="nextStep()"
                      [disabled]="onCheckDisable('peoples')">
                      {{ 'RESERVATION_MODAL.COMMON.NEXT' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>

                <!-- Dia da reserva -->
                <mat-expansion-panel
                  [expanded]="step === 4"
                  [disabled]="disableAccordion[4]"
                  (opened)="setStep(4)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP4.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        selectedDay !== ''
                          ? (selectedDay | date: 'dd/MM/yyyy')
                          : ('RESERVATION_MODAL.COMMON.SELECT' | translate)
                      }}
                      @if (loaderDay) {
                        <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> event </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'RESERVATION_MODAL.STEP4.LABEL' | translate }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      (focus)="picker.open()"
                      readonly
                      formControlName="day"
                      [matDatepickerFilter]="dateFilter"
                      (dateChange)="onSelectDay($event)" />
                    @if (formreserve.get('day')?.hasError('required')) {
                      <mat-error>{{ 'RESERVATION_MODAL.STEP4.ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>
                  <mat-datepicker #picker dateFormat="dd/MM/yyyy" [dateClass]="dateClass">
                  </mat-datepicker>

                  <mat-action-row>
                    <button mat-button color="warn" (click)="prevStep()">
                      {{ 'RESERVATION_MODAL.COMMON.PREVIOUS' | translate }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      (click)="nextStep()"
                      [disabled]="onCheckDisable('day')">
                      {{ 'RESERVATION_MODAL.COMMON.NEXT' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>

                <!-- Qual o horario -->
                <mat-expansion-panel
                  [expanded]="step === 5"
                  [disabled]="disableAccordion[5]"
                  (opened)="setStep(5)"
                  hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'RESERVATION_MODAL.STEP5.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{ selectedHour || ('RESERVATION_MODAL.COMMON.SELECT' | translate) }}
                      @if (loaderHour) {
                        <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                      } @else {
                        <span class="material-symbols-rounded icon"> alarm </span>
                      }
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  @if (listHour.length < 1) {
                    <h3>{{ 'RESERVATION_MODAL.STEP5.NO_SLOTS' | translate }}</h3>
                  } @else {
                    <mat-form-field appearance="outline">
                      <mat-label for="time">{{ 'RESERVATION_MODAL.STEP5.LABEL' | translate }}</mat-label>
                      <mat-select
                        id="time"
                        formControlName="hour"
                        (selectionChange)="onSelectHour($event)">
                        @for (hour of listHour; track $index) {
                          <mat-option [value]="hour">{{ hour }}</mat-option>
                        }
                      </mat-select>
                      @if (formreserve.get('hour')?.hasError('required')) {
                        <mat-error>{{ 'RESERVATION_MODAL.STEP5.ERROR' | translate }}</mat-error>
                      }
                    </mat-form-field>
                  }

                  <mat-action-row>
                    <button mat-button color="warn" (click)="prevStep()">
                      {{ 'RESERVATION_MODAL.COMMON.PREVIOUS' | translate }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      (click)="onGoNext(indexTab == 0 ? 1 : 2)"
                      [disabled]="onCheckDisable('hour')">
                      {{ 'RESERVATION_MODAL.STEP5.CONTINUE_BUTTON' | translate }}
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="{{ 'RESERVATION_MODAL.TABS.USER_DATA' | translate }}">
          <div class="c-modal__content">
            <form [formGroup]="form">
              @if (isDocumentMandatory) {
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'RESERVATION_MODAL.USER.CPF.LABEL' | translate }}</mat-label>
                  <input
                    (blur)="onBlur($event)"
                    matInput
                    mask="000.000.000-00"
                    placeholder="{{ 'RESERVATION_MODAL.USER.CPF.PLACEHOLDER' | translate }}"
                    formControlName="cpf" />
                  @if (!loadingCpf) {
                    <mat-icon matSuffix color="primary">how_to_reg</mat-icon>
                  }
                  @if (loadingCpf) {
                    <mat-icon matSuffix class="loading-icon" color="primary">autorenew</mat-icon>
                  }
                  @if (form.get('cpf')?.hasError('required')) {
                    <mat-error>{{ 'RESERVATION_MODAL.USER.CPF.REQUIRED' | translate }}</mat-error>
                  }
                  @if (form.get('cpf')?.hasError('invalidCpf')) {
                    <mat-error>{{ 'RESERVATION_MODAL.USER.CPF.INVALID' | translate }}</mat-error>
                  }
                </mat-form-field>
              }

              <mat-form-field appearance="outline">
                <mat-label>{{ 'RESERVATION_MODAL.USER.NAME.LABEL' | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'RESERVATION_MODAL.USER.NAME.PLACEHOLDER' | translate }}"
                  formControlName="name" />
                <mat-icon matSuffix color="primary">account_circle</mat-icon>

                @if (form.get('name')?.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.NAME.REQUIRED' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'RESERVATION_MODAL.USER.EMAIL.LABEL' | translate }}</mat-label>
                <input
                  matInput
                  placeholder="{{ 'RESERVATION_MODAL.USER.EMAIL.PLACEHOLDER' | translate }}"
                  formControlName="mail" />
                <mat-icon matSuffix color="primary">alternate_email</mat-icon>

                @if (form.get('mail')?.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.EMAIL.REQUIRED' | translate }}</mat-error>
                }
                @if (form.get('mail')?.hasError('email')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.EMAIL.INVALID' | translate }}</mat-error>
                }
                @if (form.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.EMAIL.USER_REQUIRED' | translate }}</mat-error>
                }
              </mat-form-field>

              <madero-phone-country-input [phoneControl]="$any(form.get('phone'))" [hint]="false">
              </madero-phone-country-input>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'RESERVATION_MODAL.USER.BIRTHDAY.LABEL' | translate }}</mat-label>
                <input
                  matInput
                  mask="00/00/0000"
                  placeholder="{{ 'RESERVATION_MODAL.USER.BIRTHDAY.PLACEHOLDER' | translate }}"
                  formControlName="birthday" />
                <mat-icon matSuffix color="primary">cake</mat-icon>

                @if (form.get('birthday')?.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.BIRTHDAY.REQUIRED' | translate }}</mat-error>
                } @else if (form.get('birthday')?.hasError('invalidAgeRange')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.BIRTHDAY.AGE_RANGE' | translate }}</mat-error>
                } @else if (form.get('birthday')?.hasError('invalidDayOfMonth')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.BIRTHDAY.INVALID_DATE' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label for="occasion">{{
                  'RESERVATION_MODAL.USER.OCCASION.LABEL' | translate
                }}</mat-label>
                <mat-select id="occasion" formControlName="occasion">
                  @for (ocasion of listOcasions; track $index) {
                    <mat-option [value]="ocasion.id">
                      {{
                        currentLanguage() === 'pt'
                          ? ocasion.translations?.['pt-BR'] || ocasion.name
                          : ocasion.translations?.['es-ES'] || ocasion.name
                      }}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matSuffix color="primary">star_border</mat-icon>

                @if (form.get('mail')?.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.OCCASION.REQUIRED' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label for="newCustomer">{{
                  'RESERVATION_MODAL.USER.NEW_CUSTOMER.LABEL' | translate
                }}</mat-label>
                <mat-select id="newCustomer" formControlName="newCustomer">
                  <mat-option [value]="1">{{
                    'RESERVATION_MODAL.USER.NEW_CUSTOMER.YES' | translate
                  }}</mat-option>
                  <mat-option [value]="0">{{
                    'RESERVATION_MODAL.USER.NEW_CUSTOMER.NO' | translate
                  }}</mat-option>
                </mat-select>
                <mat-icon matSuffix color="primary">new_releases</mat-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'RESERVATION_MODAL.USER.OBSERVATION.LABEL' | translate }}</mat-label>
                <input
                  maxlength="100"
                  matInput
                  placeholder="{{ 'RESERVATION_MODAL.USER.OBSERVATION.PLACEHOLDER' | translate }}"
                  formControlName="observation" />
                <mat-icon matSuffix color="primary">comment</mat-icon>

                @if (form.get('mail')?.hasError('required')) {
                  <mat-error>{{ 'RESERVATION_MODAL.USER.OBSERVATION.REQUIRED' | translate }}</mat-error>
                }
              </mat-form-field>

              <div class="polocies">
                <p>{{ 'RESERVATION_MODAL.USER.POLICIES.AVAILABILITY' | translate }}</p>
                <mat-checkbox formControlName="marketing" color="primary" class="example-margin">{{
                  'RESERVATION_MODAL.USER.POLICIES.MARKETING' | translate
                }}</mat-checkbox>
                @if (currentLanguage() === 'pt') {
                  <p>
                    {{ 'RESERVATION_MODAL.USER.POLICIES.TERMS_PREFIX' | translate }}
                    <a href="/terms" target="_blank">{{
                      'RESERVATION_MODAL.USER.POLICIES.TERMS' | translate
                    }}</a>
                    {{ 'RESERVATION_MODAL.USER.POLICIES.AND' | translate }}
                    <a href="/policies" target="_blank">
                      {{ 'RESERVATION_MODAL.USER.POLICIES.POLICIES' | translate }}
                    </a>
                    {{ 'RESERVATION_MODAL.USER.POLICIES.TERMS_SUFFIX' | translate }}
                  </p>
                } @else {
                  <p>
                    {{ 'RESERVATION_MODAL.USER.POLICIES.ES_DECLARATION' | translate }}
                    <a href="../../../../assets/files/Política%20de%20Privacidad.pdf" target="_blank">
                      {{ 'RESERVATION_MODAL.USER.POLICIES.POLICIES' | translate }}
                    </a>
                    {{ 'RESERVATION_MODAL.USER.POLICIES.TERMS_SUFFIX' | translate }}
                  </p>
                }
              </div>
            </form>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'RESERVATION_MODAL.TABS.FINISH' | translate }}">
          <div class="c-finish">
            <div class="c-finish__icon">
              <img src="../../../../assets/images/avatar.png" alt="" srcset="" />
            </div>
            <div class="c-finish__content">
              <h1>
                {{ 'RESERVATION_MODAL.FINISH.GREETING' | translate }},
                <b>{{ bodyReservation.name }}</b>
              </h1>
              <h3>{{ 'RESERVATION_MODAL.FINISH.RECEIVED' | translate }}</h3>
              <div class="c-resume">
                <p>{{ 'RESERVATION_MODAL.FINISH.WAITING_AT' | translate }}</p>
                <p class="c-resume__store">{{ selectedStore }}</p>
                <p class="c-resume__date">
                  <span class="material-symbols-rounded icon"> date_range </span
                  >{{ formatDatePtBR(bodyReservation.date) }} -
                  <span class="material-symbols-rounded icon"> access_alarm </span
                  >{{ bodyReservation.hour }}
                </p>
                <p>
                  {{ 'RESERVATION_MODAL.FINISH.RESERVED_FOR' | translate }}
                  <b>{{ bodyReservation.quantity }}</b>
                  {{ 'RESERVATION_MODAL.FINISH.PEOPLE_AT' | translate }}
                  <b>{{ selectedHall }}</b>
                </p>
                <p>
                  {{ 'RESERVATION_MODAL.FINISH.TOLERANCE' | translate }}
                  <b>{{ branchTolerance }} {{ 'RESERVATION_MODAL.FINISH.MINUTES' | translate }}</b>
                </p>
              </div>
            </div>
            <div class="c-alert">
              <span class="material-symbols-rounded icon"> thumb_up_alt </span>
              <p class="c-alert__message">
                {{ 'RESERVATION_MODAL.FINISH.CONFIRMATION_ALERT' | translate }}
              </p>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="c-modal__footer">
      <button
        mat-raised-button
        class="c-modal__footer--btn"
        (click)="prevTab()"
        [hidden]="indexTab == 0 || indexTab > 1">
        <span>{{ 'RESERVATION_MODAL.FOOTER.BACK' | translate }}</span>
      </button>
      <button
        mat-raised-button
        class="c-modal__footer--btn"
        (click)="onGoNext(indexTab == 0 ? 1 : 2)"
        [disabled]="!onValidateForms() || loading"
        [hidden]="indexTab > 1">
        @if (loading) {
          <div class="c-btn-spinner">
            <mat-spinner class="c-btn--spinner"></mat-spinner>
            <span>{{ 'RESERVATION_MODAL.FOOTER.LOADING' | translate }}</span>
          </div>
        } @else {
          <span>{{
            indexTab == 0
              ? ('RESERVATION_MODAL.FOOTER.CONTINUE' | translate)
              : ('RESERVATION_MODAL.FOOTER.BOOK' | translate)
          }}</span>
        }
      </button>
    </div>
  }
</div>
